import React, { Fragment, useContext } from 'react';
import { Col, Card, CardHeader, Table } from 'reactstrap';
import { BasicTable, Company, Country, Designation, FirstName, Language, LastName, table, tabletext, Useclass, Username } from '../../../../Constant';
import { H5, Image } from '../../../../AbstractElements';
import TableContext from '../../../../Context/Table';

const BasicTableClass = () => {
  const { data } = useContext(TableContext);
  const DynamicImage = (image) => {
    return require(`../../../../assets/images/user/${image}`);
  };
  return (
    <Fragment>
      <Col sm='12'>
        <Card>
          <CardHeader>
            <H5>{BasicTable}</H5>
            <span>
              {Useclass}
              <code>{table}</code> {tabletext}
            </span>
          </CardHeader>
          <div className='table-responsive'>
            <Table>
              <thead>
                <tr className='border-bottom-primary'>
                  <th scope='col'>{'#'}</th>
                  <th scope='col'>{FirstName}</th>
                  <th scope='col'>{LastName}</th>
                  <th scope='col'>{Username}</th>
                  <th scope='col'>{Designation}</th>
                  <th scope='col'>{Company}</th>
                  <th scope='col'>{Language}</th>
                  <th scope='col'>{Country}</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item) => (
                  <tr key={item.id} className={item.borderColor}>
                    <td>{item.id}</td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <Image className='img-fluid  img-h-30  img-30 me-2 rounded-pill' src={DynamicImage(item.img)} />
                        {item.firstName}
                      </div>
                    </td>
                    <td>{item.lastName}</td>
                    <td>{item.userName}</td>
                    <td>{item.role}</td>
                    <td>{item.company}</td>
                    <td>
                      <div className={`badge ${item.badgeClass}`}>{item.language}</div>
                    </td>
                    <td>{item.country}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card>
      </Col>
    </Fragment>
  );
};

export default BasicTableClass;
